const TaskComponent = () => import('@/views/task/TaskView')

export default [
    {
        path:'/TaskIndex',
        name:'TaskRouter',
        component:TaskComponent
    }
]